import { useQueries } from '@tanstack/react-query';
export function useCombineQueries(queries) {
    return useQueries({
        queries,
        combine: (results) => ({
            data: results.map((result) => result.data),
            isError: results.some((result) => result.isError),
            isSuccess: results.every((result) => result.isSuccess),
            refetch: () => results.map((result) => result.refetch()),
            isFetching: results.some((result) => result.isFetching)
        })
    });
}
